import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import LoginPage from "./pages/LoginPage";
import AdminPage from "./pages/AdminPage";
import PrivateRoute from "./components/PrivateRoute";
import { ThemeProvider } from "./contexts/ThemeContext";
import ContentPage from "./pages/ContentPage";
import { YahooAuthProvider } from "./contexts/YahooAuthContext";
import ChallengeDetailPage from "./pages/ChallengeDetailPage";
import { ModalProvider } from "./contexts/ModalContext";
import ScrollToTop from "./components/ui/ScrollToTop";
import { Helmet } from "react-helmet";
import MarkdownProvider from "./contexts/MarkdownContext";
import { ParallaxProvider } from "react-scroll-parallax";
import BlogDetailPage from "./pages/blogPage/BlogDetailPage";
import DraftIdeasContentPage from "./pages/DraftIdeasContentPage";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AdminProvider } from "./contexts/AdminContext";

const AppContent = () => {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route
        path="/admin"
        element={
          <PrivateRoute component={AdminPage} allowedRoles={["admin"]} />
        }
      />

      <Route path="/edit-punishments/:slug" element={<ContentPage />} />

      <Route
        path="/edit-draft-ideas/:slug"
        element={<DraftIdeasContentPage />}
      />
      <Route path="/challenges/:id" element={<ChallengeDetailPage />} />
      <Route path="/articles" element={<BlogDetailPage />} />
      <Route path="/articles/:categoryId/:id" element={<BlogDetailPage />} />
      <Route path="/articles/:id" element={<BlogDetailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  );
};

const App: React.FC = () => {
  const queryClient = new QueryClient();
  return (
    <QueryClientProvider client={queryClient}>
      <ParallaxProvider>
        <Router>
          <Helmet>
            <title>Fantasy Loser</title>
            <meta
              name="description"
              content="The premier site for fantasy sports and fantasy punishments"
            />
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0"
            />
          </Helmet>
          <YahooAuthProvider>
            <AuthProvider>
              <ThemeProvider>
                <AdminProvider>
                  <MarkdownProvider>
                    <ScrollToTop />
                    <ModalProvider>
                      <AppContent />
                    </ModalProvider>
                  </MarkdownProvider>
                </AdminProvider>
              </ThemeProvider>
            </AuthProvider>
          </YahooAuthProvider>
        </Router>
      </ParallaxProvider>
    </QueryClientProvider>
  );
};

export default App;
